export class ChattelDetailsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getChattelDetails({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/chattel-details`);
  }

  async createChattelDetails({ applicationId, chattelDetails }) {
    return this.#http.post(`/application/${applicationId}/chattel-details`, chattelDetails);
  }

  async updateChattelDetails({ applicationId, chattelDetails }) {
    return this.#http.put(`/application/${applicationId}/chattel-details`, chattelDetails);
  }

  // LEN-126: sets only ChattelDetails.PurposeOfChattel (creating the row when missing) -- no full-document
  // validation, so a POS-created row that fails an unrelated rule can still have its purpose saved.
  async setPurposeOfChattel({ applicationId, purposeOfChattel }) {
    return this.#http.put(`/application/${applicationId}/chattel-details/purpose`, {
      purposeOfChattel,
    });
  }

  async deleteChattelDetails({ applicationId }) {
    return this.#http.delete(`/application/${applicationId}/chattel-details`);
  }
}
